import { Component, Input } from '@angular/core';

@Component({
	selector: 'spr-section-progress',
	templateUrl: './section-progress.component.html',
	host: {
		class: 'flex relative items-center justify-center w-10 h-10',
	},
})
export class SectionProgressComponent {
	public readonly RADIUS = 14;

	public strokeDashoffset = 0;

	@Input()
	public set progress(progress: number) {
		this.strokeDashoffset =
			(1 - (progress || 0) / 100) * 2 * Math.PI * this.RADIUS;
	}

	constructor() {
		this.strokeDashoffset = 2 * Math.PI * this.RADIUS;
	}
}
